
import { LeaveTypeConfig, LeaveBalanceData } from '../types/leave.types';

// Maximum allowed leave duration in days
export const MAX_LEAVE_DURATION = 1500;

// Icon sizes
export const ICON_SIZE_MEDIUM = 20;

// Leave type configurations
export const LEAVE_TYPES_CONFIG: LeaveTypeConfig[] = [
    {
        type: 'Casual',
        code: 'CL',
        label: 'Casual Leave',
        color: 'blue',
        description: 'For personal or casual purposes',
        requiresDocumentation: false,
        maxDuration: 3,
        advanceNotice: 1,
    },
    {
        type: 'Medical',
        code: 'SL',
        label: 'Medical Leave',
        color: 'green',
        description: 'For medical reasons or sickness',
        requiresDocumentation: true,
        minDuration: 1,
        advanceNotice: 0,
    },
    {
        type: 'LOP',
        code: 'LOP',
        label: 'Loss of Pay',
        color: 'red',
        description: 'Unpaid leave (salary deducted)',
        requiresDocumentation: false,
        minDuration: 1,
        advanceNotice: 2,
    },
];

// Mock leave balance data
export const MOCK_LEAVE_BALANCE: LeaveBalanceData = {
    casual: { total: 12, booked: 8.5 },
    lop: { total: 0, booked: 0.5 },
    sick: { total: 10, booked: 6 },
    maternity: { total: 180, booked: 0 },
    paternity: { total: 15, booked: 0 },
    bereavement: { total: 7, booked: 0 },
    compensatory: { total: 0, booked: 0 },
};

// Status color mapping
export const STATUS_COLORS = {
    approved: 'green',
    rejected: 'red',
    pending: 'yellow',
} as const;

